import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/cuentas-de-bancos/';

/**
 * GET  Cuentas de banco
 * @returns {Promise<Array<object>>}
 */
export const getCuentasDeBanco = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Cuenta de Banco
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCuentaDeBanco = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Cuenta de Banco
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaDeBanco = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta de Banco
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaDeBanco = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta de Banco
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCuentaDeBanco = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
